var getCustomerId = function() {
    try {
        let curr = __st.cid;
        if (curr !== undefined && curr !== null && curr !== "") {
            return curr;
        }
    } catch (e) {
        return 0;
    }

    try {
        let curr = window.ShopifyAnalytics.meta.page.customerId;
        if (curr !== undefined && curr !== null && curr !== "") {
            return curr;
        }
    } catch (e) {
        return 0;
    }

    try {
        let curr = window.meta.page.customerId;
        if (curr !== undefined && curr !== null && curr !== "") {
            return curr;
        }
    } catch (e) {
        return 0;
    }

    return 0;
}

var smsbump_subscriber = (function(){
    // var subscribe_callback = null;

    var subscriberListener = function(button, hash) {

        if (!button) {
            setTimeout(subscriberListener, 50);
            return;
        }

        button.addEventListener('click', function() {
            var phone_input = document.getElementById('subscriber-phone-input').value.length > 0 ? document.getElementById('subscriber-phone-input').value.replace(/\s/g, '') : '';
            var country_select = document.getElementById('subscriber-country-select');
            var selected_country = 0;
            var customer_id = getCustomerId();

            if (typeof(country_select) != 'undefined' && country_select != null) {
                selected_country = country_select.value;
            }

            if (phone_input.length < 8 || phone_input.length > 15 || phone_input.match('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$') == null) {
                alert('Invalid phone number!');
                return;
            }
            var http = new XMLHttpRequest();
            var pageUrl = window.location.href;

            var url = "https://smsbump.com/subscribers/confirm-subscription/" + encodeURIComponent(hash);
            if(hash === ''){
                url = "https://smsbump.com/subscribers/confirm-subscription/";
            }

            var params = "phone=" + phone_input + "&country=" + selected_country  + "&pageUrl=" + encodeURIComponent(pageUrl) + "&customerId=" + customer_id;
            http.open("POST", url, true);

            http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

            http.onreadystatechange = function() {
                if(http.readyState == 4 && http.status == 200) {
                    var result = JSON.parse(http.responseText);

                    if (typeof subscribe_callback == 'function') {
                        subscribe_callback({
                            data: result,

                        });
                    }

                    var message = result.message;
                    if(result.error){
                        message =  'Error! ' +  message;
                    }
                  
                    window.location.href = "/pages/confirmation";
                  
                }
            }
            http.send(params);
        });
    }

    return {
        getSubscriberListener: function(button,hash) {
            return subscriberListener(button,hash);
        }
    }
})();

(function() {
    var domIsReady = (function(domIsReady) {
        var isBrowserIeOrNot = function() {
            return (!document.attachEvent || typeof document.attachEvent === "undefined" ? 'not-ie' : 'ie');
        }

        domIsReady = function(callback) {
            if(callback && typeof callback === 'function'){
                if(isBrowserIeOrNot() !== 'ie') {
                    document.addEventListener("DOMContentLoaded", function() {
                        return callback();
                    });
                } else {
                    document.attachEvent("onreadystatechange", function() {
                        if(document.readyState === "complete") {
                            return callback();
                        }
                    });
                }
            } else {
                console.error('The callback is not a function!');
            }
        }
        return domIsReady;
    })(domIsReady || {});

    let getUrlParameter =  function(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    domIsReady(function() {
        var smsbumpSubscriberButton = document.getElementById('confirm-text-marketing-subscription');
        var hash = getUrlParameter('s');
        smsbump_subscriber.getSubscriberListener(smsbumpSubscriberButton,hash);
    });
})();